"use client";

import { useQuery } from "@apollo/client";
import { Group } from "@mantine/core";

import { Text } from "@/components/ui/elements";
import classes from "./_css/FollowerOfficeCountSection.module.css";
import { gradientTextStyle } from "./_function/workReward";
import { followedByOfficeCountQuery } from "./_graphql";

/**
 * 施設からのフォロー数はマイページ本体のクエリと切り離して取得する。
 * 取得に失敗してもマイページ全体を壊さないよう、この区画ごと非表示にする。
 */
export function FollowerOfficeCountSection() {
  const { loading, error, data } = useQuery(followedByOfficeCountQuery);

  if (loading || error) return null;

  return (
    <>
      <Group
        justify="space-between"
        align="center"
        wrap="wrap"
        gap="sm"
        mb="md"
      >
        <Text fw="bold" fz="sm" c="dark.7">
          あなたをフォローしている施設
        </Text>
        <Group gap={4} align="baseline">
          <Text
            fz={{ base: 20, sm: 22 }}
            fw="bold"
            style={gradientTextStyle.indigo}
          >
            {data?.viewer.followedByOfficeCount ?? 0}
          </Text>
          <Text c="dark.7" fz="sm" fw="500">
            施設
          </Text>
        </Group>
      </Group>
      <hr className={classes.divider} />
    </>
  );
}
